module.exports = __webpack_public_path__ + "static/fonts/Oswald-Regular.dab2e77.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oswald/Oswald-Regular.ttf
// module id = 1165
// module chunks = 5